module.exports = __webpack_public_path__ + "static/media/33_B.98d0ddd8.png";